import { render, staticRenderFns } from "./fishingParadise.vue?vue&type=template&id=12bbd788&scoped=true"
import script from "./fishingParadise.vue?vue&type=script&lang=js"
export * from "./fishingParadise.vue?vue&type=script&lang=js"
import style0 from "./fishingParadise.vue?vue&type=style&index=0&id=12bbd788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bbd788",
  null
  
)

export default component.exports